import React, { useState } from "react";
import classNames from "classnames";
import TimeFilter from "components/TimeFilter";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import * as moment from "moment";

export default ({
  title = "Title",
  Icon = null,
  loading = true,
  setTime = () => {},
  time = null,
  statsClass,
  backgroundClass,
  stats = {},
  children,
  onDetailsOpen = () => {},
  onDetailsClosed = () => {},
  netThriving = false,
  recognition = false,
}) => {
  const [detailsOpened, setDetailsOpened] = useState(false);

  function printPercentageNumber(number1, number2) {
    if (loading) {
      return "-";
    }

    var percentageNumber = Math.floor((number1 / number2) * 100);

    if (netThriving) {
      return null;
    }

    if (isNaN(percentageNumber)) {
      return 0;
    }

    return `${percentageNumber}%`;
  }

  function printNumber(number) {
    if (loading) {
      return "-";
    }

    if (!number) {
      return 0;
    }

    return number;
  }

  return (
    <div
      className={classNames({
        "stats-card": true,
        [backgroundClass]: true,
        [statsClass]: true,
      })}
    >
      <div className="stats-header">
        {Icon && <Icon className="statsIcon" />}
        <span className="title-stats">{title}</span>
        {!netThriving && (
          <TimeFilter time={time} setTime={setTime} color={"white"} />
        )}
      </div>
      <div className="stats-content pt-4">
        <div className="stats-count">
          {netThriving && stats?.happiness_meter >= 0 && (
            <div>
              <div className="netThrivingRightSide">
                <span className="member-engaged">Net Thriving Score:</span>
                <span className="netThriving-stats">
                  {stats?.net_thriving_score}
                </span>
              </div>
              <div className="netThrivingRightSide">
                <span className="member-engaged">Happiness Meter:</span>
                <span className="netThriving-stats">
                  {stats?.happiness_meter}%
                </span>
              </div>
            </div>
          )}
          {!netThriving && !recognition && (
            <>
              <div className="member-engaged">Members Engaged:</div>
              <div className="v-stats">
                {printPercentageNumber(
                  stats?.engaged_users_count,
                  stats?.total_activities
                )}
              </div>
            </>
          )}
          {recognition && (
            <>
              <div className="member-engaged">Wall of Fame</div>
              <div className="v-stats">{stats?.total_count ?? "-"}</div>
            </>
          )}
          <div className="viewDetails">
            <p
              style={{ textDecoration: "underline", marginBottom: "5px" }}
              className="color-white p-cursor"
              onClick={() => {
                setDetailsOpened(true);
                onDetailsOpen();
              }}
            >
              View Details
            </p>
          </div>
        </div>
        <div className="v-stats-table">
          <table className="color-white">
            <tbody className="stats-body">
              {netThriving && stats?.happiness_meter >= 0 && (
                <>
                  <tr>
                    <td className="stats-heading netThrivingHeading">
                      Last Team Idea
                    </td>
                    <td className="stats-value netThrivingValue">
                      {!moment(stats?.last_team_brightidea).isValid()
                        ? "N/A"
                        : moment(stats?.last_team_brightidea).format(
                            "MMM D, YYYY"
                          )}
                    </td>
                  </tr>
                  <tr>
                    <td className="stats-heading netThrivingHeading">
                      Last Check-in
                    </td>
                    <td className="stats-value netThrivingValue">
                      {!moment(stats?.last_team_checkin).isValid()
                        ? "N/A"
                        : moment(stats?.last_team_checkin).format(
                            "MMM D, YYYY"
                          )}
                    </td>
                  </tr>
                  <tr>
                    <td className="stats-heading netThrivingHeading">
                      Last Wall Of Fame
                    </td>
                    <td className="stats-value netThrivingValue">
                      {!moment(stats?.last_celebration).isValid()
                        ? "N/A"
                        : moment(stats?.last_celebration).format("MMM D, YYYY")}
                    </td>
                  </tr>
                </>
              )}

              {stats?.initiated_count >= 0 ? (
                <tr>
                  <td className="stats-heading">Request Initiated:</td>
                  <td className="stats-value">
                    {printNumber(stats?.initiated_count)}
                  </td>
                </tr>
              ) : null}
              {stats?.recognizers >= 0 && (
                <tr>
                  <td className="stats-heading">Recognizors</td>
                  <td className="stats-value">{stats?.recognizers}</td>
                </tr>
              )}
              {stats?.entertained_count >= 0 ||
              stats?.engaged_users_count >= 0 ? (
                <tr>
                  <td className="stats-heading">Engaged:</td>
                  <td className="stats-value">
                    {stats?.entertained_count ?? stats?.engaged_users_count}
                  </td>
                </tr>
              ) : null}
              {stats?.recievers >= 0 && (
                <tr>
                  <td className="stats-heading">Receivers</td>
                  <td className="stats-value">{stats?.recievers}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div
        className={classNames({
          detailsContainer: true,
          detailsOpen: detailsOpened,
          "col-xl-3 col-lg-4": true,
        })}
      >
        <div className="detailsRoot">
          <div
            className={classNames({
              detailsHeader: true,
              [backgroundClass]: true,
            })}
          >
            {Icon && <Icon className="statsIcon" />}
            <span className="title-stats">{title}</span>
            <span>
              <CloseIcon
                style={{
                  cursor: "pointer",
                  width: "24px",
                  height: "24px",
                  fill: "white",
                }}
                onClick={() => {
                  setDetailsOpened(false);
                  onDetailsClosed();
                }}
              />
            </span>
          </div>
          <div id="right-sidebar-details" className={"detailsBody"}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};
